<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  isShared: {
    type: Boolean,
    default: false
  },
  sizeClass: {
    type: String,
    default: 'text-lg'
  },
  colorClass: {
    type: String,
    default: 'text-gray-700'
  }
})
const svgSize = computed(() => {
  if (props.sizeClass === 'text-xl') {
    return '1.4em'
  }
  return '1em'
})
</script>

<template>
  <svg
    v-if="isShared"
    :width="svgSize"
    :height="svgSize"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    :class="['inline align-text-bottom', sizeClass, colorClass]">
    <defs>
      <mask id="peopleMask">
        <rect width="48" height="48" fill="white"/>
        <path d="M16 32.85C16 32.2125 16.1657 31.6266 16.4972 31.0922C16.8286 30.5578 17.2689 30.15 17.8182 29.8688C18.9924 29.2875 20.1856 28.8516 21.3977 28.5609C22.6098 28.2703 23.8409 28.125 25.0909 28.125C26.3409 28.125 27.572 28.2703 28.7841 28.5609C29.9962 28.8516 31.1894 29.2875 32.3636 29.8688C32.9129 30.15 33.3532 30.5578 33.6847 31.0922C34.0161 31.6266 34.1818 32.2125 34.1818 32.85V33.75C34.1818 34.3687 33.9593 34.8984 33.5142 35.3391C33.0691 35.7797 32.5341 36 31.9091 36H18.2727C17.6477 36 17.1127 35.7797 16.6676 35.3391C16.2225 34.8984 16 34.3687 16 33.75V32.85ZM35.8295 36C36.0379 35.6625 36.1941 35.3016 36.2983 34.9172C36.4025 34.5328 36.4545 34.1437 36.4545 33.75V32.625C36.4545 31.8 36.2225 31.0078 35.7585 30.2484C35.2945 29.4891 34.6364 28.8375 33.7841 28.2938C34.75 28.4063 35.6591 28.5984 36.5114 28.8703C37.3636 29.1422 38.1591 29.475 38.8977 29.8688C39.5795 30.2438 40.1004 30.6609 40.4602 31.1203C40.8201 31.5797 41 32.0813 41 32.625V33.75C41 34.3687 40.7775 34.8984 40.3324 35.3391C39.8873 35.7797 39.3523 36 38.7273 36H35.8295ZM25.0909 27C23.8409 27 22.7708 26.5594 21.8807 25.6781C20.9905 24.7969 20.5455 23.7375 20.5455 22.5C20.5455 21.2625 20.9905 20.2031 21.8807 19.3219C22.7708 18.4406 23.8409 18 25.0909 18C26.3409 18 27.411 18.4406 28.3011 19.3219C29.1913 20.2031 29.6364 21.2625 29.6364 22.5C29.6364 23.7375 29.1913 24.7969 28.3011 25.6781C27.411 26.5594 26.3409 27 25.0909 27ZM36.4545 22.5C36.4545 23.7375 36.0095 24.7969 35.1193 25.6781C34.2292 26.5594 33.1591 27 31.9091 27C31.7008 27 31.4356 26.9766 31.1136 26.9297C30.7917 26.8828 30.5265 26.8313 30.3182 26.775C30.8295 26.175 31.2225 25.5094 31.4972 24.7781C31.7718 24.0469 31.9091 23.2875 31.9091 22.5C31.9091 21.7125 31.7718 20.9531 31.4972 20.2219C31.2225 19.4906 30.8295 18.825 30.3182 18.225C30.5833 18.1312 30.8485 18.0703 31.1136 18.0422C31.3788 18.0141 31.6439 18 31.9091 18C33.1591 18 34.2292 18.4406 35.1193 19.3219C36.0095 20.2031 36.4545 21.2625 36.4545 22.5Z" fill="black"/>
      </mask>
    </defs>
    <path d="M21.18 9.18C20.42 8.42 19.4 8 18.34 8H8C5.8 8 4.02 9.8 4.02 12L4 36C4 38.2 5.8 40 8 40H40C42.2 40 44 38.2 44 36V16C44 13.8 42.2 12 40 12H24L21.18 9.18Z" fill="currentColor" mask="url(#peopleMask)"/>
  </svg>
  <span
    v-else
    :class="[sizeClass, colorClass, 'material-icons-round align-text-bottom']">
    folder
  </span>
</template>

<style scoped>
</style>